module.exports = __webpack_public_path__ + "img/img18.0e607df7.png";